import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent {

  @Input() dyanamicId:string;
  @Input() name:string;
  @Input() checkBoxLabel:string;
  @Input() checkBoxClass: string;
  @Input() isRequired: boolean;
  @Input() status: boolean;
  @Input() disabled:boolean;
  @Output() check:EventEmitter<boolean>=new EventEmitter() ;
}
